var video_viewer_default = {
  "video_player": "GnI-n",
  "videoOverlay": "RVlAP",
  "video_container": "cZjzn"
};
export {
  video_viewer_default as default
};
//# sourceMappingURL=video-viewer-scss.js.map
